import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ApolloWrapperProvider from 'apollo/Provider';
import Layout from 'components/generalUI/MainLayout';
import ChatWidget from 'components/generalUI/ChatWidget';
import { ConfigProvider } from 'antd';
import getAntdLocale from 'i18n/antdLocale';
import Routes from 'routes';
import posthog from 'posthog-js';
import Maintenance from 'views/Maintenance';

const App: FC = () => {
  const { i18n } = useTranslation();
  const postHogApiKey = process.env.REACT_APP_POSTHOG_API_KEY || '';

  posthog.init(postHogApiKey, {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'always',
  });

  const isMaintenanceMode = process.env.REACT_APP_UNDER_MAINTENANCE === 'true';
  const antdLocale = getAntdLocale(i18n.language);

  if (isMaintenanceMode) {
    return (
      <ConfigProvider locale={antdLocale}>
        <ApolloWrapperProvider>
          <Maintenance />
        </ApolloWrapperProvider>
      </ConfigProvider>
    );
  }

  return (
    <ConfigProvider locale={antdLocale}>
      <ApolloWrapperProvider>
        <Layout>
          <Routes />
        </Layout>
        <ChatWidget />
      </ApolloWrapperProvider>
    </ConfigProvider>
  );
};

export default App;
